module.exports = __webpack_public_path__ + "files/0db2668207eca5852b07fdea7662786c.png";